import { render, staticRenderFns } from "./case_reviews.vue?vue&type=template&id=f6196a56&scoped=true"
import script from "./case_reviews.vue?vue&type=script&lang=js"
export * from "./case_reviews.vue?vue&type=script&lang=js"
import style0 from "./case_reviews.vue?vue&type=style&index=0&id=f6196a56&prod&scoped=true&lang=less"
import style1 from "./case_reviews.vue?vue&type=style&index=1&id=f6196a56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6196a56",
  null
  
)

export default component.exports